module.exports = __webpack_public_path__ + "img/nosotros_02-conocimiento-para-que-tomes-decisiones.cf128343.jpg";